module.exports = __webpack_public_path__ + "media/images/welcome_page_manage_courses-67b87a73613c37b414299b85212233dd.png";